import React, { useEffect } from "react";
import { Modal, Form, Input, Row, Col, Card, Switch, ColorPicker } from "antd";
import { ModeleService } from "../../services/ModeleService";
import { catchError } from "../../services/DaoService";
import Toast from "../../helpers/Toast";
import PropTypes from "prop-types";
import CustomFormItem from "../utils/form/CustomFormItem";

const ModeleEditForm = ({ visible, uid, onUpdate, onCancel }) => {
	const [form] = Form.useForm();
	const [editing, setEditing] = React.useState(false);
	const [validationErrors, setValidationErrors] = React.useState({});

	useEffect(() => {
		if (uid) {
			setEditing(true);
			ModeleService.getInstance()
				.find(uid)
				.then((response) => {
					form.setFieldsValue(response.data);
				})
				.catch((error) => {
					catchError(error);
				})
				.finally(() => {
					setEditing(false);
				});
		}
	}, [uid, form]);

	const handleSave = () => {
		setEditing(true);
		form
			.validateFields()
			.then((values) => {
				ModeleService.getInstance()
					.update(uid, values)
					.then((response) => {
						Toast.success(response.message);
						onUpdate(response.data);
					})
					.catch((error) => {
						const errors = error.response.data;
						if (errors.validation && Object.keys(errors?.errors).length) {
							setValidationErrors(errors.errors);
						} else {
							catchError(error);
						}
					})
					.finally(() => {
						setEditing(false);
					});
			})
			.catch(() => {
				setEditing(false);
			});
	};

	return (
		<Modal
			width={"50%"}
			open={visible}
			onCancel={onCancel}
			okText='Enregistrer'
			onOk={handleSave}
			title='Modifier le type de dossier'
			forceRender
		>
			<Card loading={editing} style={{ marginBottom: 20 }}>
				<Form
					layout='vertical'
					form={form}
					name='editModeleForm'
					initialValues={{
						enabled: 1,
					}}
				>
					<Row gutter={24}>
						<Col xs={24} md={24} lg={12}>
							<CustomFormItem
								label='Nom'
								name='nom'
								rules={[{ required: true, message: "Veuillez saisir le nom !" }]}
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<Input type='text' />
							</CustomFormItem>
						</Col>
						<Col xs={24} md={24} lg={12}>
							<CustomFormItem
								label='Code'
								name='code'
								rules={[
									{ required: true, message: "Veuillez saisir le code !" },
									{ max: 3, message: "Le code doit avoir 3 caractères!" },
									{ min: 3, message: "Le code doit avoir 3 caractères!" },
								]}
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<Input type='text' />
							</CustomFormItem>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col xs={24} md={24} lg={24}>
							<CustomFormItem
								label='Description'
								name='description'
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<Input.TextArea rows={4} />
							</CustomFormItem>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col xs={24} md={12} lg={8}>
							<CustomFormItem rules={[{ required: true, message: "Veuillez saisir la couleur!" }]}
								label='Couleur'
								name='couleur'
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<ColorPicker format='hex' />
							</CustomFormItem>
						</Col>

						<Col xs={24} md={12} lg={8}>
							<CustomFormItem
								label='Active'
								name='enabled'
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
								valuePropName='checked'
							>
								<Switch />
							</CustomFormItem>
						</Col>

						<Col xs={24} md={12} lg={8}>
							<CustomFormItem
								label="Default"
								name="default" valuePropName='checked'
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<Switch />
							</CustomFormItem>
						</Col>
					</Row>
				</Form>
			</Card>
		</Modal>
	);
};

export default ModeleEditForm;

ModeleEditForm.propTypes = {
	visible: PropTypes.bool,
	onUpdate: PropTypes.func,
	onCancel: PropTypes.func,
	uid: PropTypes.string.isRequired,
};
